import component from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component('searchPeoplePicker', component)
    // Vue.mixin({
    // })

    Vue.prototype.$searchPeoplePicker = {
    }
  }
}

// This exports the plugin object.
export default Plugin
